import { createFileRoute, redirect } from '@tanstack/react-router'
import { WorkspaceSettingsLayout } from '@/features/workspaces/settings'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings'
)({
  beforeLoad: ({ context, params, location }) => {
    if (!context.canManageWorkspace) {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId',
        params,
      })
    }

    if (/\/settings\/?$/.test(location.pathname)) {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId/settings/general',
        params,
        replace: true,
      })
    }
  },
  component: WorkspaceSettingsLayout,
})
